import Quick from './quick'

promokit.youtube({
    el: '#player1',
    youtubeid: 'L21EyBytnVs',
    controls: true
});
promokit.youtube({
    el: '#player2',
    youtubeid: 'L21EyBytnVs',
    controls: true,
    autoplay: true
});
promokit.layer({
    el: '#layer-1',
    buttons: '.p-header__play'
});


let page = promokit.page({
    type: 'basic',
    game: 'bns',
    cnb: true,
    menu: false,
    headerButton: {
        el:'.header-button',
        cookie: {
            type: 'year',
            key: 'INDEX_WEB_210512_dualwield',
            value: false
        },
        home: true,
        event:false,
        update:true,
        sns: true,
        theme: 'white'
    },
    footer: {
        fixed: true,
        theme: 'black'
    },
    components: false,
});




promokit.preload({
    delay: 500,
    complete: function() {
        $('body').css('overflow', 'auto');
        Quick();


        $(document).on('click', '.p-header__scroll', function(){
            $('html, body').stop().animate({ scrollTop : $('.p-sec1').offset().top }, 800);
        });
    }
});




// WEBPACK FOOTER //
// ./src/js/index.js